import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import {
    deleteExportDetailsData,
} from "@gemeco/Services/GemecoInventoryDataService";

type HandlerType = ApiHandler<{ customerID: string; onSuccess?: () => void }, {}>;

export const RequestDataFromDeleteScheduleApi: HandlerType = async (props: any) => {
    props.apiResult = await deleteExportDetailsData({ customerID: props.parameter.customerID });
};

export const chain = [RequestDataFromDeleteScheduleApi];

const gemecoStopScheduleHandler = createHandlerChainRunner(chain, "GemecoStopScheduleHandler");
export default gemecoStopScheduleHandler;
